export const COLLEGE_CORNER_FETCH_COMMON_DATA =
  'COLLEGE_CORNER:COMMON_DATA';
export const COLLEGE_CORNER_FETCH_COMMON_DATA_SUCCESS =
  'COLLEGE_CORNER:COMMON_DATA_SUCCESS';
export const COLLEGE_CORNER_FETCH_COMMON_DATA_FAILURE =
  'COLLEGE_CORNER:COMMON_DATA_FAILURE';

export const COLLEGE_CORNER_FETCH_COLLEGE_TEAMS =
  'COLLEGE_CORNER:COLLEGE_TEAMS';
export const COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_SUCCESS =
  'COLLEGE_CORNER:COLLEGE_TEAMS_SUCCESS';
export const COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_FAILURE =
  'COLLEGE_CORNER:COLLEGE_TEAMS_FAILURE';

export const COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS =
  'COLLEGE_CORNER:COLLEGE_PLAYERS';
export const COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_SUCCESS =
  'COLLEGE_CORNER:COLLEGE_PLAYERS_SUCCESS';
export const COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_FAILURE =
  'COLLEGE_CORNER:COLLEGE_PLAYERS_FAILURE';

export const COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS =
  'COLLEGE_CORNER:JUNIOR_PROSPECTS';
export const COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_SUCCESS =
  'COLLEGE_CORNER:JUNIOR_PROSPECTS_SUCCESS';
export const COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_FAILURE =
  'COLLEGE_CORNER:JUNIOR_PROSPECTS_FAILURE';

export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS =
  'COLLEGE_CORNER:COLLEGE_RANKINGS';
export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SUCCESS =
  'COLLEGE_CORNER:COLLEGE_RANKINGS_SUCCESS';
export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_FAILURE =
  'COLLEGE_CORNER:COLLEGE_RANKINGS_FAILURE';

export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT =
  'COLLEGE_CORNER:COLLEGE_RANKINGS_SNAPSHOT';
export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_SUCCESS =
  'COLLEGE_CORNER:COLLEGE_RANKINGS_SNAPSHOT_SUCCESS';
export const COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_FAILURE =
  'COLLEGE_CORNER:COLLEGE_RANKINGS_SNAPSHOT_FAILURE';
